


























import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import CommonMixin from '@/mixins/CommonMixin';

@Component
export default class CustomField extends Mixins(CommonMixin) {
  // Props
  @Prop(Boolean) public readonly isReadOnly!: boolean;
  @Prop(Object) public readonly line!: any;

  public inputChanged() {
    this.$emit('enter');
    if (this.line.value_index === undefined) {
      this.line.value_index = -1;
      this.line.value = null;
    } else if (this.line.value_index === -1) {
      this.line.value = null;
    } else {
      const items = this.buildOptionList(this.line.values_nl);
      if (items) {
        this.line.value = items[this.line.value_index].text;
      } else {
        this.line.value = null;
      }
    }
  }
}
